import { ValidationStates } from '@opengov/component-library/dist';
import { ISavedView } from '@opengov/reporting-types/src/reportSavedView';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isTitleDuplicate } from '../../../savedViews/isTitleDuplicate';
import { SAVED_VIEW_DESCRIPTION_MAX_LENGTH, SAVED_VIEW_TITLE_MAX_LENGTH } from './types';

export type ISavedViewTitleAndDescription = {
  description: string;
  title: string;
  reportConfiguration?: string;
  setAsDefault?: boolean;
};

export function useSavedViewForm(existingSavedViews?: ISavedView[]) {
  const [description, setDescription] = useState('');
  const [descriptionValidationState, setDescriptionValidationState] = useState(ValidationStates.None);
  const [title, setTitle] = useState('');
  const [titleHadFocus, setTitleHadFocus] = useState(false);
  const [titleValidationState, setTitleValidationState] = useState(ValidationStates.None);
  const navigate = useNavigate();

  const handleTitleChange = (newTitle: string) => {
    const isValid = newTitle.trim().length > 0 && newTitle.length <= SAVED_VIEW_TITLE_MAX_LENGTH;
    const isDuplicate = isValid && isTitleDuplicate(newTitle, existingSavedViews);
    setTitle(newTitle);
    setTitleValidationState(isValid && !isDuplicate ? ValidationStates.Success : ValidationStates.Error);
  };

  const handleDescriptionChange = (newDescription: string) => {
    setDescription(newDescription);
    const isWithinLimit = newDescription.length <= SAVED_VIEW_DESCRIPTION_MAX_LENGTH;
    setDescriptionValidationState(isWithinLimit ? ValidationStates.Success : ValidationStates.Error);
  };

  const handleTitleBlur = () => {
    setTitleHadFocus(true);
    if (titleValidationState === ValidationStates.None) {
      setTitleValidationState(ValidationStates.Error);
    }
  };

  const formValid =
    titleValidationState === ValidationStates.Success && descriptionValidationState !== ValidationStates.Error;
  const showTitleEmptyMessage =
    titleHadFocus && (titleValidationState === ValidationStates.None || title.trim().length === 0);
  const showTitleDuplicateMessage = titleHadFocus && isTitleDuplicate(title, existingSavedViews);

  return {
    title,
    description,
    titleValidationState,
    navigate,
    formValid,
    showTitleEmptyMessage,
    showTitleDuplicateMessage,
    handleTitleChange,
    handleDescriptionChange,
    handleTitleBlur
  };
}
